module.exports = __webpack_public_path__ + "media/img/favicon-16x16-69aabcf617b93d0875b9666b33c95141.png";